import { sharedLogout as A, clearSessionCookie as P, syncSessionCookie as U } from "../../../auth-lib/utils/sessionCookies.js";
import { ERROR_CODE as O } from "../../constants/error.js";
import { CustomError as r } from "../../errors/customError.js";
import { getAccessToken as w, accessTokenExpired as b, getRefreshToken as E, cleanTokens as S, saveTokens as v } from "../../util/authenication/index.js";
import { tokenExpired as L } from "../../util/authenication/token.js";
const l = /* @__PURE__ */ new Map(), N = () => new r(
  "Your session has expired. Please log in again.",
  O.GRAPHQL.FORCE_LOGOUT
), G = () => new r("Your login session changed. Please try again."), J = async (t, i = {}) => {
  const o = w();
  if (!b() && (!i.force || i.rejectedAccessToken !== void 0 && i.rejectedAccessToken !== o))
    return o;
  const s = E();
  if (!s) return null;
  if (!t) throw new r("The login service is not configured.");
  const C = A(), c = JSON.stringify([t, s]), h = l.get(c);
  if (h) return h;
  const R = async () => {
    var g, k, d;
    const u = new AbortController(), x = setTimeout(() => u.abort(), 15e3);
    try {
      const a = await fetch(t, {
        method: "POST",
        cache: "no-store",
        signal: u.signal,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          query: "mutation RefreshAccessToken($refreshToken: String!) { refreshAccessToken(refreshToken: $refreshToken) }",
          variables: { refreshToken: s }
        })
      }), e = await a.json().catch(() => null);
      if (E() !== s || w() !== o || A() !== C)
        throw G();
      if (a.status === 401 || ((g = e == null ? void 0 : e.errors) == null ? void 0 : g.some(
        (f) => {
          var p, m, y;
          return ((p = f.extensions) == null ? void 0 : p.code) === "UNAUTHENTICATED" || ((m = f.extensions) == null ? void 0 : m.code) === "UNAUTHORIZED" || ((y = f.extensions) == null ? void 0 : y.subCode) === O.GRAPHQL.FORCE_LOGOUT;
        }
      )))
        throw P(o), S(!0), N();
      const n = (k = e == null ? void 0 : e.data) == null ? void 0 : k.refreshAccessToken;
      if (!a.ok || (d = e == null ? void 0 : e.errors) != null && d.length || typeof n != "string" || L(n, 0))
        throw new r(
          "Unable to refresh your session. Please try again."
        );
      return U(n, o), v(n, s), n;
    } finally {
      clearTimeout(x);
    }
  }, T = Promise.resolve().then(R).finally(() => l.delete(c));
  return l.set(c, T), T;
};
export {
  J as renewAccessToken,
  N as sessionExpiredError
};
//# sourceMappingURL=refreshToken.js.map
